class ProductMarketplaceFbaStorageHealth {
    constructor({asinLimit, isHazmat, itemVolume,  volumeUnits, salesRank, removalInProgressCount, healthyInventoryLevel,
                    inboundRecommendedQuantity, sellThrough, inventoryAge={}, unitsShipped={}, weeksOfCover={},
                    updatedDate=new Date()}){
        this.asinLimit = asinLimit;
        this.isHazmat = isHazmat;
        this.itemVolume = itemVolume;
        this.volumeUnits = volumeUnits;
        this.salesRank = salesRank;
        this.sellThrough = sellThrough;
        this.removalInProgressCount = removalInProgressCount;
        this.healthyInventoryLevel = healthyInventoryLevel;
        this.inboundRecommendedQuantity = inboundRecommendedQuantity;
        this.inventoryAge = inventoryAge;
        this.unitsShipped = unitsShipped;
        this.weeksOfCover = weeksOfCover;

        this.updatedDate = new Date(updatedDate);
    }

    //The statics below could move to mws3 but keeping them here enables better auto completion. This object is used in mws3 record
    static buildInventoryAgeFromMws(mwsReportData){
        return {
            age0To90: mwsReportData.invAge0To90Days,
            age91To180: mwsReportData.invAge91To180Days,
            age181To270: mwsReportData.invAge181To270Days,
            age271To365: mwsReportData.invAge271To365Days,
            age365Plus: mwsReportData.invAge365PlusDays,
        }
    }

    static buildUnitsShippedFromMws(mwsReportData){
        return {
            last7Days: mwsReportData.unitsShippedT7,
            last30Days: mwsReportData.unitsShippedT30,
            last90Days:mwsReportData.unitsShippedT90,
        }
    }

    static buildWeeksOfCoverFromMws(mwsReportData){
        return {
            from7DaySales: null,
            from30DaySales: mwsReportData.weeksOfCoverT30 ? mwsReportData.weeksOfCoverT30 : "Infinite",
            from90DaySales: mwsReportData.weeksOfCoverT90 ? mwsReportData.weeksOfCoverT90: "Infinite",
            from180DaySales: null,
            from365DaySales: null,
        }
    }
}

export { ProductMarketplaceFbaStorageHealth };